// models/metrics/metasearchMetrics/google-hotel-ads/googleHotelAdsMetrics.js

// connectivity
import MetricHotelSuspendedCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricHotelSuspendedCount";
import MetricMissedParticipationCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricMissedParticipationCount";
import MetricNoAvailabilityCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricNoAvailabilityCount";
import MetricNoLandingPageCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricNoLandingPageCount";
import MetricNoPriceCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricNoPriceCount";

// conversion
import MetricBookingCountGha from "models/metrics/metasearchMetrics/google-hotel-ads/conversion/MetricBookingCount";
import MetricConversionGha from "models/metrics/metasearchMetrics/google-hotel-ads/conversion/MetricConversion";
import MetricHotelAverageLeadValueMicrosRate from "models/metrics/metasearchMetrics/google-hotel-ads/conversion/MetricHotelAverageLeadValueMicrosRate";
import MetricHotelPriceDifferencePercentageRate from "models/metrics/metasearchMetrics/google-hotel-ads/conversion/MetricHotelPriceDifferencePercentageRate";
import MetricRevenuePerclickGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricRevenuePerclick";
import MetricRoiGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricRoi";

// performance
import MetricClicksGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricClicks";
import MetricClickShare from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricClickShare";
import MetricCpcGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricCpc";
import MetricCsrGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricCsr";
import MetricCtrGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricCtr";
import MetricGeneratedGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricGenerated";
import MetricImpr from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricImpr";
import MetricSpentGha from "models/metrics/metasearchMetrics/google-hotel-ads/performance/MetricSpent";

// visibility
import MetricEligImprGha from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricEligImprGha";
import MetricImprShareGha from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricImprShareGha";
import MetricMissedImprGha from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricMissedImprGha";
import MetricSearchAbsoluteTopImpressionShare from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchAbsoluteTopImpressionShare";
import MetricSearchBudgetLostAbsoluteTopImpressionShareRate from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchBudgetLostAbsoluteTopImpressionShareRate";
import MetricSearchBudgetLostImpressionShareRate from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchBudgetLostImpressionShareRate";
import MetricSearchRankLostAbsoluteTopImpressionShare from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchRankLostAbsoluteTopImpressionShare";
import MetricSearchRankLostImpressionShare from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchRankLostImpressionShare";
import MetricSearchRankLostTopImpressionShareRate from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchRankLostTopImpressionShareRate";
import MetricSearchTopImpressionShareRate from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchTopImpressionShareRate";

// others
import MetricLivePricingConfigIssueCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricLivePricingConfigIssueCount";
import MetricLivePricingNotAvailableCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricLivePricingNotAvailableCount";
import MetricLivePricingNotTriggeredCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricLivePricingNotTriggeredCount";
import MetricLivePricingOtherReasonCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricLivePricingOtherReasonCount";
import MetricLivePricingTechnicalIssueCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricLivePricingTechnicalIssueCount";
import MetricNoTaxBreakdownCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricNoTaxBreakdownCount";
import MetricOpportunityCount from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricOpportunityCount";
import MetricOtherReasonCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricOtherReasonCount";
import MetricParticipationCount from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricParticipationCount";
import MetricParticipationPercentRate from "models/metrics/metasearchMetrics/google-hotel-ads/connectivity/MetricParticipationPercentRate";
import MetricSearchBudgetLostTopImpressionShareRate from "models/metrics/metasearchMetrics/google-hotel-ads/visibility/MetricSearchBudgetLostTopImpressionShareRate";

const googleHotelAdsMetrics = [
    // connectivity
    new MetricHotelSuspendedCount(),
    new MetricMissedParticipationCount(),
    new MetricNoAvailabilityCount(),
    new MetricNoLandingPageCount(),
    new MetricNoPriceCount(),
    // conversion
    new MetricBookingCountGha(),
    new MetricConversionGha(),
    new MetricHotelAverageLeadValueMicrosRate(),
    new MetricHotelPriceDifferencePercentageRate(),
    new MetricRevenuePerclickGha(),
    new MetricRoiGha(),
    // performance
    new MetricClickShare(),
    new MetricClicksGha(),
    new MetricCpcGha(),
    new MetricCsrGha(),
    new MetricCtrGha(),
    new MetricGeneratedGha(),
    new MetricImpr(),
    new MetricSpentGha(),
    // visibility
    new MetricEligImprGha(),
    new MetricImprShareGha(),
    new MetricMissedImprGha(),
    new MetricSearchAbsoluteTopImpressionShare(),
    new MetricSearchBudgetLostAbsoluteTopImpressionShareRate(),
    new MetricSearchBudgetLostImpressionShareRate(),
    new MetricSearchRankLostAbsoluteTopImpressionShare(),
    new MetricSearchRankLostImpressionShare(),
    new MetricSearchRankLostTopImpressionShareRate(),
    new MetricSearchTopImpressionShareRate(),
    // others
    new MetricLivePricingConfigIssueCount(),
    new MetricLivePricingNotAvailableCount(),
    new MetricLivePricingNotTriggeredCount(),
    new MetricLivePricingOtherReasonCount(),
    new MetricLivePricingTechnicalIssueCount(),
    new MetricNoTaxBreakdownCount(),
    new MetricOpportunityCount(),
    new MetricOtherReasonCount(),
    new MetricParticipationCount(),
    new MetricParticipationPercentRate(),
    new MetricSearchBudgetLostTopImpressionShareRate(),
];

export function findMetricById(metricId) {
    return googleHotelAdsMetrics.find((metricClass) => metricClass.field === metricId);
}

export default googleHotelAdsMetrics;
